// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1BoT-","header":"MessagesList_header__chvQl","chat":"MessagesList_chat__Nq0j7"};